<div [hidden]="!includeLabel">
  <label for="{{name}}">{{getLabelName()}}</label>
</div>
<div *ngIf="detailMode; then showSpan else showInput"></div>
<ng-template #showInput>
  <input type="number" #field class="form-control" [id]="(id === null ? name : id)" [name]="name" [value]="value"
    [max]="max" [min]="min" [disabled]="readOnly" (input)="changeValue($event, false, true)"
    (keyup)="pressKey($event)" />
</ng-template>
<ng-template #showSpan>
  <span type="text" #field [id]="(id === null ? name : id)">
    {{value}}
  </span>
  <hr *ngIf="includeLabel" />
</ng-template>

<div *ngIf="!detailMode">
  <app-input-feedback [hidden]="!validateRequired()" [feedbackMessage]="spanRequired"></app-input-feedback>
  <app-input-feedback [hidden]="this.max==null || this.value<=this.max" [feedbackMessage]="'Máximo: '+this.max"></app-input-feedback>
  <app-input-feedback [hidden]="this.min==null || this.value>=this.min" [feedbackMessage]="'Mínimo: '+this.min"></app-input-feedback>
</div>
